export default "__VITE_ASSET__a6433f23__"